<template>
  <div style="">
    <common-header :menu="{}" />
    <h2 class="chart-title">全記録</h2>

    <analytics-header title="実績"/>
    <div>
      <div class="achievement-row">
        <achivement-item style="display: inline-block" v-for="a in achievements.continuous.slice(0,2)" :text="a.toString()" :key="a.toString()" />
      </div>
      <div class="achievement-row">
        <achivement-item style="display: inline-block" v-for="a in achievements.counts.slice(0,2)" :text="a.toString()" :key="a.toString()" />
      </div>
      <div v-show="achievements.continuous.length === 0 && achievements.counts.length === 0">
        実績はまだありません
      </div>

      <basic-button
        v-show="achievements.continuous.length > 2 || achievements.counts.length > 2"
        label="もっと見る" @click="goAchieveList"/>
    </div>

    <bar-chart-with-title
      v-for="work in records.works"
      :key="work.title"
      :title="work.title"
      :chart-config="work.data"
      style="margin: 2vh 0 8vh 0"
    />

    <common-footer :menu="{home:true,analytics:false}"/>
  </div>
</template>

<script>
// import * as Chart from 'chart.js'
import CommonHeader from "./CommonHeader";
import {RecordManager} from "./common/RecordManager";
import BarChartWithTitle from "./analytics/BarChartWithTitle";
import AnalyticsHeader from "./analytics/AnalyticsHeader";
import CommonFooter from "./CommonFooter";
import {AchievementManager} from "./common/achievement/AchievementManager";
import AchivementItem from "./common/achievement/AchivementItem";
import BasicButton from "./common/BasicButton";
export default {
  name: "Analytics",
  components: {BasicButton, AchivementItem, CommonFooter, AnalyticsHeader, BarChartWithTitle, CommonHeader},
  head: {
    script: [
      // { type: 'text/javascript', src: 'https://cdn.jsdelivr.net/npm/chart.js@3.7.1/dist/chart.min.js', body: false},
    ],
  },
  data() {
    return {
      records: RecordManager.getInstance().getRecords(),
      achievements: AchievementManager.getInstance().getAchievements(),
    }
  },
  mounted() {
    window.ac = AchievementManager.getInstance()
    window.rm = RecordManager.getInstance()
    window.allReset = () => {
      window.ac.reset()
      window.rm.reset()
    }
    // RecordManager.getInstance().debug()
  },
  methods: {
    goAchieveList() {
      location.href = '/achievements'
    }
    // init() {
    //   const ctx = document.getElementById('myChart').getContext('2d');
    //   const myChart = new Chart(ctx, RecordManager.getInstance().getChartConfig());
    //   myChart.canvas.parentNode.className = 'chartParent'
    // }
  }
}
</script>

<style>
body {
  /*background: rgb(240,240,240);*/
}
.chartParent {
  width: 70vw;
  height: 40vh;
  margin: auto;
  background: white;
}
</style>
<style scoped>
h2 {
  color: #e74a23;
  /*background: linear-gradient(124deg,#e74a23,#e9671f,#ec841b,#efa118);*/
  padding: 1.8vh 0;
  font-size: 4vh;
  border-bottom: 4px solid #e74a23;
}
.achievement-row {
  margin: 1vh 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Analytics.vue